import React from 'react'
import PropTypes from 'prop-types'
import Link from '@salesforce/retail-react-app/app/components/link'
import {Link as RouteLink} from 'react-router-dom'
// Utils
import {categoryUrlBuilder} from '@salesforce/retail-react-app/app/utils/url'
import {
    Box,
    Flex,
    Text,
    useMultiStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {FormattedMessage} from 'react-intl'

/**
 * SeoLinks component displays a list of SEO-related links for a given product.
 *
 * This component takes a product object as a prop, which should contain
 * an array of SEO links. Each link is displayed as a list item with a
 * clickable link that navigates to the URL built from the link's ID.
 *
 * @component
 * @param {Object} props - The component props
 * @param {Object} props.product - The product object containing SEO links
 * @param {Array} props.product.c_seoLinks - An array of SEO link objects
 * @param {string} props.product.c_seoLinks[].id - The unique identifier for the link
 * @param {string} props.product.c_seoLinks[].displayName - The display name for the link
 * @returns {JSX.Element} A list of SEO links
 */
const SeoPDPLinks = ({product, ...props}) => {
    const styles = useMultiStyleConfig('ProductViewContainer')
    return (
        <>
            {product?.c_seoLinks?.length > 0 && (
                <Box ml={'20px'} {...props}>
                    <Text as={'h3'} {...styles.productViewPageSeoLinksTitle}>
                        <FormattedMessage
                            defaultMessage="ALSO DISCOVER:"
                            id="seo_link.title.also_discover"
                        />
                    </Text>
                    <Flex as={'ul'} {...styles.productViewPageSeoLinks}>
                        {product?.c_seoLinks?.map((link) => (
                            <Box as="li" key={link.id} {...styles.productViewPageSeoLinksLists}>
                                <Link as={RouteLink} to={categoryUrlBuilder(link)}>
                                    {link.displayName}
                                </Link>
                            </Box>
                        ))}
                    </Flex>
                </Box>
            )}
        </>
    )
}

SeoPDPLinks.propTypes = {
    product: PropTypes.object
}

export default SeoPDPLinks
